<div class="col-12 col-md-12">
  <!-- Setttings and tabs section -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a id="tabs" class="nav-link active" data-bs-toggle="tab" data-bs-target="#general"><em class="fa fa-info-circle"
      style="color: darkblue; margin: 2px;"></em>{{"General" | translate}}</a>
    </li>
    <li class="nav-item">
      <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#Keys"><em class="fa fa-regular fa-key"
      style="color:rgb(187, 54, 54); margin: 2px;"></em>{{"Keys" | translate}}</a>
    </li>
    @if (Loginprivilege ==='admin') {
      <li class="nav-item">
        <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#groups"><em class="fa fa-group"
        style="color: darkmagenta; margin: 2px;"></em>{{"Groups" | translate}}</a>
      </li>
    }
    @if (Loginprivilege ==='admin') {
      <li class="nav-item">
        <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#device"><em class="fa fa-mobile-phone"
        style="color:red; margin: 2px;"></em>{{"Devices" | translate}}</a>
      </li>
    }
    @if (Loginprivilege ==='admin') {
      <li class="nav-item">
        <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#browsers">
          <em class="fa fa-chrome" style="color:orange; margin: 2px;"></em>{{"Browsers" | translate}}
        </a>
      </li>
    }

    @if (Loginprivilege ==='admin') {
      <li class="nav-item">
        <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#users"><em class="fa fa-user"
        style="color:green; margin: 2px;"></em>{{"User" | translate}}</a>
      </li>
    }

    @if (Loginprivilege ==='admin') {
      <li class="nav-item">
        <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#chat"><em class="fa fa-comments"
        style="color:blue; margin: 2px;"></em>{{"Chat" | translate}}</a>
      </li>
    }
  </ul>

  <div class="tab-content border" style="height:81vh;overflow-y:auto;overflow-x:hidden;margin: 3vh;">
    <div id="general" class="tab-pane fade show active">
      <app-general></app-general>
    </div>
    <div id="Keys" class="tab-pane fade">
      <app-keys></app-keys>
    </div>
    <div id="groups" class="tab-pane fade">
      <app-group></app-group>
    </div>
    <div id="device" class="tab-pane fade">
      <app-device></app-device>
    </div>
    <div id="browsers" class="tab-pane fade">
      <app-browsers></app-browsers>
    </div>
    <div id="users" class="tab-pane fade">
      <app-users></app-users>
    </div>
    <div style="height: 100%;" id="chat" class="tab-pane fade">
      <app-admin-chat></app-admin-chat>
    </div>
  </div>
</div>